import React, { useEffect, useState, useRef } from 'react';

/**
 * A custom hook for subscribing on a target element height.
 *
 * @param {Object} targetRef - The observed target element react reference
 *
 * @returns {{height: number}}
 */
const useHeightObserver = (targetRef) => {
    const [height, setHeight] = useState();
    const cachedRef = useRef();

    useEffect(() => {
        if (targetRef.current) {
            cachedRef.current = targetRef.current;
        }

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    const { height } = entry.contentRect;

                    setHeight(Math.floor(height));
                }
            }
        });

        resizeObserver.observe(cachedRef.current);

        return () => {
            resizeObserver.unobserve(cachedRef.current);
        };
    }, [targetRef]);

    return { height };
};

export default useHeightObserver;
